import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, Optional } from "@angular/core";
import { Observable, catchError, map, throwError } from "rxjs";
import { MAP_SEARCH_ENDPOINTS, MapSearchEndpoints } from "../map-search.tokens";
import { MapSearchErrorTypes, MapSearchResult } from "../models/map-search.models";
import { PoiSearchResultResponseBody, convertSearchResultResponseBodyToSearchResults } from "./map-search.converter";

const SEARCH_RESULTS_LIMIT = 10;

export interface MapSearchServiceModel {
    getSearchResults(searchQuery: string): Observable<MapSearchResult[]>;
}

@Injectable({
    providedIn: "root",
})
export class MapSearchApiService implements MapSearchServiceModel {
    constructor(
        private readonly httpClient: HttpClient,
        @Optional() @Inject(MAP_SEARCH_ENDPOINTS) private readonly endpoints: MapSearchEndpoints
    ) {}

    public getSearchResults(searchQuery: string): Observable<MapSearchResult[]> {
        return this.httpClient
            .get<PoiSearchResultResponseBody>(this.endpoints.omniSearch, {
                params: { query: searchQuery.trim(), limit: SEARCH_RESULTS_LIMIT },
                headers: {
                    Accept: "application/vnd.pansa.geocode.v2+json",
                },
            })
            .pipe(
                map((response) => convertSearchResultResponseBodyToSearchResults(response)),
                catchError((error) => throwError(() => ({ type: MapSearchErrorTypes.CannotGetSearchResults, error })))
            );
    }
}
